(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PricingDialogController', PricingDialogController);

    PricingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pricing', 'Contract', 'MiscService', 'ToastrService', 'contractEntity', 'contractPage'];

    function PricingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pricing, Contract, MiscService, ToastrService, contractEntity, contractPage) {
        var vm = this;

        vm.pricing = entity;
        vm.contractPage = contractPage;
        vm.contractEntity = contractEntity;

        vm.clear = clear;
        vm.save = save;
        vm.priceModels = ['ONCALL', 'FIXED'];
        vm.onCallOnOffs = ['ON', 'OFF'];
        vm.fixedPriceTypes = ['CTS', 'EUR'];
        vm.fixedPriceUnitTypes = ['LB', 'MT', 'KG'];
        vm.priceModel = 'FIXED';
        vm.pricingYears = MiscService.returnPricingYears();
        vm.pricingMonths = [
            {value: 'MAR', title: 'Mar'},
            {value: 'MAY', title: 'May'},
            {value: 'JUL', title: 'Jul'},
            {value: 'OCT', title: 'Oct'},
            {value: 'DEC', title: 'Dec'}
        ];
        vm.onTextClick = onTextClick;

        vm.activateFixedPriceType = function (option) {
            vm.pricing.priceType = option;
        };

        vm.activatePriceModel = function (option) {
            vm.priceModel = option;
        };

        vm.activateOnCallOnOff = function (option) {
            vm.pricing.onOff = option;
        };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.showError = false;
            vm.errorData = {};
            vm.isSaving = true;
            if (vm.pricing.id && vm.pricing.id !== null && vm.pricing.id > 0) {
                Pricing.update(vm.pricing, onSaveSuccess, onSaveError);
            } else {
                if (vm.contractPage !== undefined && vm.contractPage) {
                    if (vm.contractEntity === null || vm.contractEntity.id === null) { // in case when contract is not created when we add pricing
                        onSaveSuccess(vm.pricing);
                    } else { // in case when we add pricing to existing contract
                        vm.pricing.contract = {
                            id: (vm.contractEntity === null || vm.contractEntity.id === null) ? null : vm.contractEntity.id,
                            quantity: (vm.contractEntity === null || vm.contractEntity.id === null) ? null : vm.contractEntity.quantity
                        };
                        vm.pricing.fixed = 0;
                        Pricing.save(vm.pricing, onSaveSuccess, onSaveError);
                    }
                } else {
                    Pricing.save(vm.pricing, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:pricingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            if (vm.contractEntity !== null && vm.contractEntity.id !== null) {
                ToastrService.success("Successfully saved Pricing", "Success!");
            }
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function onTextClick($event) {
            $event.target.select();
        }
    }
})();
